import { AuthError } from '@/@vxapp/@Enums/PHP/core/Enums/Errors/AuthError'

export type NormalizedAuthError = {
  code: string | null
  httpStatus: number | null
  messages: string[]
  requestId?: string | null
  source?: string | null
}

function coerceArray<T = any>(val: any): T[] {
  if (!val) return []
  return Array.isArray(val) ? val : [val]
}

export function normalizeApiError(errOrData: any): NormalizedAuthError {
  try {
    const data = errOrData?.data ?? errOrData ?? {}
    const topMessage = errOrData?.message ?? data?.message ?? null
    const httpStatus = errOrData?.responseCode ?? errOrData?.status ?? data?.responseCode ?? null
    const topError = errOrData?.error ?? data?.error ?? null
    const nestedErrors = coerceArray(data?.errors)

    const messages: string[] = []
    if (topMessage && typeof topMessage === 'string') messages.push(topMessage)
    for (const e of nestedErrors) {
      if (e?.message && typeof e.message === 'string') messages.push(e.message)
    }

    const codeCandidate = (nestedErrors[0]?.error ?? topError ?? null) as string | null
    const code: string | null = codeCandidate && Object.values(AuthError).includes(codeCandidate as AuthError)
      ? codeCandidate
      : (codeCandidate ? String(codeCandidate) : null)

    const requestId = data?.requestID ?? data?.requestId ?? null
    const source = data?.source ?? null

    return {
      code: code ?? null,
      httpStatus: typeof httpStatus === 'number' ? httpStatus : null,
      messages,
      requestId,
      source,
    }
  } catch (_e) {
    return { code: null, httpStatus: null, messages: [], requestId: null, source: null }
  }
}

const LoginErrorMessage: Record<string, string> = {
  [AuthError.USER_NOT_FOUND]: 'Invalid email or password',
  [AuthError.USER_INVALID_PASSWORD]: 'Invalid email or password',
  [AuthError.USER_NO_PASSWORD]: 'Invalid email or password',
  [AuthError.USER_LOGIN_DISABLED]: 'Your account is disabled. Contact support.',
  [AuthError.USER_NO_ROLE]: 'Your account is missing a role. Contact support.',
  [AuthError.INVALID_AUTH_ROLE]: 'Your account role is invalid. Contact support.',
  [AuthError.ROLE_NOT_FOUND]: 'Your account role is invalid. Contact support.',
  [AuthError.ROLE_DOES_NOT_EXIST]: 'Your account role is invalid. Contact support.',
  default: 'Authentication failed. Please try again.',
}

export function mapLoginErrorToMessage(code?: string | null): string {
  if (!code) return LoginErrorMessage.default
  return LoginErrorMessage[code] || LoginErrorMessage.default
}


